import React from 'react';
import CountryFlag from 'react-country-flag';
import lookup from 'country-code-lookup';

function CountryWithFlag({countryName}) {
    const countryCode = lookup.byCountry(countryName);

    if (!countryCode) {
        return <div>{countryName}</div>;
    }

    return (
        <div className={"w-20"}>
            <CountryFlag countryCode={countryCode.iso2} svg className={"inline"}/> &nbsp;
            {countryName}
        </div>
    );
};

export default CountryWithFlag;
